import { render } from "./hero.vue?vue&type=template&id=7d9c7c1a&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=7d9c7c1a&lang=scss&scoped=true"

import exportComponent from "/Users/simongustafson/projekt/triathlon/triathlon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9c7c1a"]])

export default __exports__